module.exports = __webpack_public_path__ + "media/images/athletes/1525-acacb2671acf7000b6416db25ed4f5b7.png";